// extracted by mini-css-extract-plugin
export default {"container":"A0MHY","info":"_YVju"};